export function isColissimoPaymentMessage(content: string): boolean {
  return content.includes('Paiement Colissimo effectué');
}

export function isChronopostPaymentMessage(content: string): boolean {
  return content.includes('Paiement Chronopost effectué');
}

export function isMondialRelayPaymentMessage(content: string): boolean {
  return content.includes('Paiement Mondial Relay effectué');
}

export function isDeliveryPaymentMessage(content: string): boolean {
  return (
    isColissimoPaymentMessage(content) ||
    isChronopostPaymentMessage(content) ||
    isMondialRelayPaymentMessage(content)
  );
}
